import { environment } from '../../../environments/environment';

export class Service {
	protected readonly weiquiApi = environment.weiquiApi;
	protected readonly version = environment.apiversion;
	protected readonly loginApi = environment.loginApi;
}
